import { Capacitor } from '@capacitor/core';

const REVENUECAT_API_KEY = process.env.REACT_APP_REVENUECAT_API_KEY;
const ENTITLEMENT_ID = 'ilik_plus';
const PRODUCT_ID = 'ilik_plus_monthly';

let Purchases = null;

const isNative = () => Capacitor.isNativePlatform();

const loadPurchases = async () => {
  if (Purchases) return Purchases;
  try {
    const mod = await import('@revenuecat/purchases-capacitor');
    Purchases = mod.Purchases;
    return Purchases;
  } catch {
    return null;
  }
};

export const initRevenueCat = async () => {
  if (!isNative()) return;
  const P = await loadPurchases();
  if (!P) return;
  try {
    await P.configure({ apiKey: REVENUECAT_API_KEY });
  } catch (err) {
    console.error('RevenueCat configure error:', err.message);
  }
};

export const checkPremiumStatus = async () => {
  if (!isNative()) return null;
  const P = await loadPurchases();
  if (!P) return null;
  try {
    const { customerInfo } = await P.getCustomerInfo();
    return !!customerInfo.entitlements.active[ENTITLEMENT_ID];
  } catch {
    return null;
  }
};

export const purchaseMonthly = async () => {
  if (!isNative()) return null;
  const P = await loadPurchases();
  if (!P) return null;
  try {
    const { offerings } = await P.getOfferings();
    if (offerings.current && offerings.current.availablePackages.length > 0) {
      const { customerInfo } = await P.purchasePackage({ aPackage: offerings.current.availablePackages[0] });
      return customerInfo;
    }
    const { customerInfo } = await P.purchaseProduct({ productIdentifier: PRODUCT_ID });
    return customerInfo;
  } catch (err) {
    if (err.userCancelled) return null;
    throw err;
  }
};

export const restorePurchases = async () => {
  if (!isNative()) return null;
  const P = await loadPurchases();
  if (!P) return null;
  try {
    const { customerInfo } = await P.restorePurchases();
    return {
      isPremium: !!customerInfo.entitlements.active[ENTITLEMENT_ID],
      customerInfo,
    };
  } catch (err) {
    throw err;
  }
};

export { isNative };
